import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import debounce from 'lodash.debounce';
import { userAction } from "../../actions/user.action";
import Tabs from "@material-ui/core/Tabs/Tabs";
import Tab from "@material-ui/core/Tab/Tab";
import withStyles from "@material-ui/core/styles/withStyles";
import CenteredContent from "../../components/UI/CenteredContent";
import DemoBanner from "../../components/DemoBanner";
import { LoginForm, RegistrationForm }from "./components";

const styles = theme => ({
  signupForm: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row !important'
    }
  },
  form: {
    width: "100%", // Fix IE11 issue.
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    },
    '& label': {
      [theme.breakpoints.down('md')]: {
        fontSize: 16
      }
    },
    '& input, & select': {
      [theme.breakpoints.down('md')]: {
        fontSize: 16
      }
    },
    '& svg': {
      fontSize: 17,
      marginBottom: 6
    },
    '& .DayPickerInput': {
      width: '100%',
    },
    '& .LoginBirthdatePicker': {
      width: '100%',
    },
  },
  cta: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      fontSize: 12
    }
  },
  ctaSignup: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      fontSize: 12
    }
  },
  loginHeader: {
    [theme.breakpoints.down('md')]: {
      backgroundColor: '#FAFAFA'
    }
  },
  tab: {
    '& span': {
      [theme.breakpoints.down('md')]: {
        fontSize: 12
      }
    }
  },
  error: {
    color: theme.palette.error.main,
    [theme.breakpoints.down('md')]: {
      fontSize: 15,
      textAlign: 'center'
    }
  },
  signinBtn: {
    [theme.breakpoints.down('md')]: {
      minHeight: 30,
      marginTop: 9
    }
  },
  pwBtn: {
    [theme.breakpoints.down('md')]: {
      float: 'right'
    },
    '& button': {
      [theme.breakpoints.down('md')]: {
        textTransform: 'capitalize',
        fontSize: 12,
        marginTop: -2
      }
    }
  },
  mobileLeftCol: {
    [theme.breakpoints.down('md')]: {
      width: '47%',
      borderRight: '1px solid #dddddd',
      paddingRight: '2%'
    }
  },
  mobileRightCol: {
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      left: '50%'
    }
  },
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bdList: [],
      bdListUnverified: []
    };

    this.debouncedFetch = debounce(this.loadUnverifiedBrokerDealers, 400);
  }

  handleChangeTabs = (e, v) => {
    this.props.history.push(v === 0 ? '/login': '/signup');
  };

  handleLoggedIn = () => {
    const { history, location } = this.props;
    const redirectUrl = location.state && location.state.from ? location.state.from : '/Portal/';
    history.push(redirectUrl);
  }

  loadBrokerDealers = (inputValue, callback = console.error) => {
    this.props
      .dispatch(userAction.getBrokerDealers(inputValue,true, null))
      .then(res => {
        /**
         * @type {Array<{name: string | null, v: boolean}>}
         */
        const data = res.data
        const cleanedDataVerified = data.filter(_ => _.name && _.v).map(_ => ({ name: _.name }));
        const cleanedDataUnverified = data.filter(_ => _.name && !_.v).map(_ => ({ name: _.name }));

        this.setState({ bdList: cleanedDataVerified, bdListUnverified: cleanedDataUnverified });
      })
      .catch(error => callback(error, null));
  };

  loadUnverifiedBrokerDealers = (inputValue, callback) => {
    /**
     * @type {Array<{name: string}>}
     */
    const bdListUnverified = this.state.bdListUnverified;
    const matches = bdListUnverified
      .filter(_ => _.name.search(new RegExp('^' + inputValue, 'i')) >= 0);
    const results = matches.length ?
      matches.map(({ name }) => ({ label: name, value: name }))
      :
      [{ label: 'Not Found', value: 'Not Found' }];
    callback(results);
  };


  componentDidMount() {
    const { user } = this.props;
    this.loadBrokerDealers();
    if (user.loggedIn) {
      this.handleLoggedIn();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (nextProps.user.loggedIn) {
      this.handleLoggedIn();
    }
  }

  render() {
    const { classes, user, location, app } = this.props;
    const { bdList, bdListUnverified } = this.state;
    const tabIndex = location.pathname === '/login' ? 0 : 1;
    return (
      <React.Fragment>
        {app.demoMode && <DemoBanner />}
        <CenteredContent
          isSignup={tabIndex === 1}
          headerContent={
            <Tabs
              value={tabIndex}
              onChange={this.handleChangeTabs}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab className={classes.tab} label="SIGN IN" />
              <Tab className={classes.tab} label="SIGN UP" />
            </Tabs>
          }
        >
          {
            tabIndex === 0 &&
            <LoginForm classes={classes}/>
          }
          {
            tabIndex === 1 &&
            <React.Fragment>
              <RegistrationForm
                classes={classes}
                bdList={bdList}
                bdListUnverified={bdListUnverified}
                debouncedFetch={this.debouncedFetch}
                signingUp={user.signingUp}
              />
            </React.Fragment>
          }
        </CenteredContent>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    user: state.user,
    app: state.app
  };
};
export default withRouter(withStyles(styles)(connect(mapStateToProps)(Login)));



// WEBPACK FOOTER //
// ./src/containers/Login/index.jsx